import React, { useState } from 'react'
import axios from 'axios';
import * as CONSTANTS from "../../../CONSTANTS";
import './mini-dashboard.css';
import { toast } from 'react-toastify';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Link } from 'react-router-dom';

function DashboardOnvite2({user, selectedEvent, setUpdateAction}) {

  const [processing, setProcessing]                   = useState(false);
  const [editMode, setEditMode]                       = useState(false);
  const [formData, setFormData]                       = useState({
    weddingOnviteMessage: selectedEvent.weddingOnviteMessage || '',
    weddingVowsA: selectedEvent.weddingVowsA || '',
    weddingVowsB: selectedEvent.weddingVowsB || ''
  });
  const [changedFields, setChangedFields] = useState({});

  const handleCKEditorChange = (fieldName, data) => {
    setFormData(prev => ({ ...prev, [fieldName]: data }));
    setChangedFields(prev => ({ ...prev, [fieldName]: data }));
  };

  const handleEditToggle = () => {
    setEditMode(!editMode);
    if (!editMode) setChangedFields({});
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        data: {
          ...changedFields
        },
        eventId: selectedEvent._id
      };

      const result = await axios.put(`${CONSTANTS.API_URL}annivites/onvite/update-about/vows/v1`, payload, {
                    headers: {
                          token: 'Bearer ' + user.accessToken,
                        },
                  });
      
      setProcessing(false);
      setUpdateAction(prev => prev + 1);
      toast.success(result.data.message);
      setEditMode(false);
    } catch (error) {
      console.error(error);
      toast.error("Failed to update");
    }
  };

  return (
    <div className="dashboard-inner-box">
      <div className="header-bar">
        <h5>Onvite Details 2</h5>
        <button className="btn btn-sm btn-main" onClick={handleEditToggle}>
          {editMode ? "Cancel" : "Edit"}
        </button>
      </div>

       <div className="info-fields-grid">
        <CKEditorField
          label="Wedding Onvite Message"
          name="weddingOnviteMessage"
          value={formData.weddingOnviteMessage}
          editable={editMode}
          onChange={handleCKEditorChange}
        />
        <CKEditorField
          label="Wedding Vows A"
          name="weddingVowsA"
          value={formData.weddingVowsA}
          editable={editMode}
          onChange={handleCKEditorChange}
        />
        <CKEditorField
          label="Wedding Vows B"
          name="weddingVowsB"
          value={formData.weddingVowsB}
          editable={editMode}
          onChange={handleCKEditorChange}
        />
      </div>

      <p className="mt-3">
        <Link to={'/couple-event/' + selectedEvent._id}>View onsite</Link>
      </p>
      {editMode && (
        <div className="form-actions">
          <button className="btn btn-main" onClick={handleSubmit} disabled={processing}>
            {
              processing ? "Processing" : "Save Changes"
            }
          </button>
        </div>
      )}

    </div>
  )
}

function CKEditorField({ label, name, value, editable, onChange }) {
  return (
    <div className="field-item full-width">
      <label>{label}</label>
      {editable ? (
        <CKEditor
          editor={ClassicEditor}
          data={value}
          onChange={(event, editor) => {
            const data = editor.getData();
            onChange(name, data);
          }}
        />
      ) : (
        <div
          className="text-display rich"
          dangerouslySetInnerHTML={{ __html: value || '<em>—</em>' }}
        />
      )}
    </div>
  );
}

export default DashboardOnvite2